import React from 'react';
import './Footer.css';

export default function Footer() {
  return (
    <footer className="footer">
      <span className="footer-copy">2026 © Siddharth Tiwari</span>
      <div className="footer-webring">
        <a href="https://math-webring.vercel.app/#siddharthtiwari.com?nav=prev" style={{color: 'var(--text-muted)', fontSize: '1rem'}}>←</a>
        <a href="https://math-webring.vercel.app/#siddharthtiwari.com" target="_blank" rel="noopener noreferrer">
          <img src="https://math-webring.vercel.app/math-webring-white.svg" alt="Math Webring" style={{width: '20px', height: 'auto', display: 'block'}} />
        </a>
        <a href="https://math-webring.vercel.app/#siddharthtiwari.com?nav=next" style={{color: 'var(--text-muted)', fontSize: '1rem'}}>→</a>
      </div>
    </footer>
  );
}
